import React from 'react';
import { costRows } from '../data/pains';
export function CostSection() {
  return <section aria-labelledby="costo-title" className="border-b border-line bg-ink" data-id="element-40" data-mp="9c6izcspilt0">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 lg:py-16" data-id="element-41" data-mp="4l7z638if5l0">
        <h2 id="costo-title" className="mx-auto max-w-2xl text-center text-lg font-black leading-tight tracking-tight text-ivory sm:text-2xl" data-id="element-42" data-mp="4jdfstcvzlj1">
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mx-auto mt-6 max-w-xl overflow-hidden rounded-2xl border border-line" data-id="element-43" data-mp="3mqufkltmf7qh">
          <table className="w-full table-fixed border-collapse text-left" data-id="element-44" data-mp="3mt73rgpz2ebz">
            <caption className="sr-only" data-id="element-45" data-mp="3hrzxjm3h9n7f">Costo real de seguir sin un sistema</caption>
            <thead data-id="element-46" data-mp="3cu7upx1aogog">
              <tr className="bg-surfaceAlt" data-id="element-47" data-mp="3curg5nq5ln78">
                <th scope="col" className="w-3/5 px-3 py-2.5 text-[10px] font-bold uppercase tracking-wide text-ivory sm:px-4" data-id="element-48" data-mp="1g0mvr5wt3vfl">
                  Sin MegaPack
                </th>
                <th scope="col" className="px-3 py-2.5 text-right text-[10px] font-bold uppercase tracking-wide text-danger sm:px-4" data-id="element-49" data-mp="p7tii42feap1">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-50" data-mp="fa71nc1kg92f">
              {costRows.map(row => <tr key={row.item} className="border-t border-line bg-surface" data-id="element-51" data-mp="fbqhj1jb8i3o">
                  <th scope="row" className="px-3 py-2.5 text-left text-[11px] font-normal leading-snug text-muted sm:px-4 sm:text-[12px]" data-id="element-52" data-mp="k8qkv4orz6r3">
                    {row.item}
                  </th>
                  <td className="px-3 py-2.5 text-right text-[11px] font-bold text-ivory sm:px-4 sm:text-[12px]" data-id="element-53" data-mp="y91g0jx4b7i2">
                    {row.cost}
                  </td>
                </tr>)}
              <tr className="border-t border-accent/40 bg-surfaceAlt" data-id="element-54" data-mp="1qwnl5wlzuk71">
                <th scope="row" className="px-3 py-3 text-left text-[11px] font-black leading-snug text-ivory sm:px-4 sm:text-[12px]" data-id="element-55" data-mp="1vndn0zv7o4wz">
                  No tener un sistema
                </th>
                <td className="px-3 py-3 text-right text-[11px] font-black text-accent sm:px-4 sm:text-[12px]" data-id="element-56" data-mp="20kjaog063oi0">
                  + de $27.990
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mx-auto mt-6 max-w-xs text-center text-sm font-black leading-snug tracking-tight text-ivory sm:max-w-md sm:text-xl" data-id="element-57" data-mp="1rkml8c5yellw">
          “El próximo conflicto puede ser diferente.”
        </p>
      </div>
    </section>;
}